import { defineModule } from "direct-vuex";

import { moduleActionContext, axiosInstance as axios } from "@/store/";

export interface StarHubState {
  apiEndpoint: string;
}

const module = defineModule({
  namespaced: true as const,
  state: {
    apiEndpoint: process.env.VUE_APP_STARHUB_API_ENDPOINT || "",
  } as StarHubState,

  mutations: {},
  actions: {
    async requestAuthorization(context): Promise<void> {
      const { state } = moduleActionContext(context, module);
      if (!state.apiEndpoint) return console.error("StarHub API endpoint not set.");
      if (!process.env.VUE_APP_STARHUB_CLIENT_ID) return console.error("StarHub client ID not set.");

      console.log("Requesting authorization from StarHub...");
      console.log("StarHub API endpoint:", state.apiEndpoint);
      const url = new URL("/RequestAuthorization", state.apiEndpoint);
      url.searchParams.append("client_id", process.env.VUE_APP_STARHUB_CLIENT_ID);
      url.searchParams.append("redirect_uri", window.location.origin + "/cb/cnbauth");
      url.searchParams.append("response_type", "code");
      url.searchParams.append("state", "CG");

      window.location.href = url.href;
    },
    async handlerequestAuthorizationResponse(context, code: string): Promise<boolean> {
      const { state, rootDispatch } = moduleActionContext(context, module);
      try {
        if (!state.apiEndpoint) throw new Error("StarHub API endpoint not set.");

        const response = await axios.post("/auth/starhub/auth", {
          code,
        });
        await rootDispatch.authentication.setJWT(response.data.token);
        await rootDispatch.authentication.whoami(true);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
  },
});

export default module;
